// extracted by mini-css-extract-plugin
module.exports = {"PersonalDetails":"PersonalDetails_PersonalDetails__1vjL3","inputs":"PersonalDetails_inputs__1D1vO","btns":"PersonalDetails_btns__Zw6PY"};